import { type ReactNode } from 'react';
import { formatFollowers } from '@/utils/formatters';

type Props = { total: number; goal: number };

function pct(a: number, b: number): number {
  return Math.min(100, Math.max(0, (a / Math.max(b, 1)) * 100));
}

export function TeamGoalBar({ total, goal }: Props): ReactNode {
  const progress = pct(total, goal);
  const met = total >= goal;
  return (
    <div>
      <div className="flex justify-end text-[10px] tabular-nums text-text-tertiary">
        <span className={met ? 'text-brand-red' : 'text-text-primary'}>
          {formatFollowers(total)}
        </span>
        <span className="ml-0.5">/ {formatFollowers(goal)}</span>
      </div>
      <div className="mt-1 h-1.5 overflow-hidden rounded-full bg-white/[0.04]">
        <div
          className="h-full rounded-full bg-brand-red/80 transition-all duration-500"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
